import CommonUiIconComponent from 'webapp/components/common/ui-icon';
import type { Args } from 'webapp/components/common/upgrade-plan-base';
import CommonUpgradePlanBaseComponent from 'webapp/components/common/upgrade-plan-base';

export default abstract class CommonUpgradePlanTextComponent<
	T extends Args,
> extends CommonUpgradePlanBaseComponent<T> {
	<template>
		{{#if @icon}}
			<CommonUiIconComponent @name={{@icon}} @size={{if @iconSize @iconSize "sm"}} />
		{{/if}}{{this.text}}
	</template>
}
